import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class HomeawayActionModel extends Model {
  @attr('boolean') cancelledByOwner!: boolean;
  @attr('boolean') cancelledByTraveller!: boolean;

  @belongsTo('booking', { inverse: 'homeawayAction', async: false })
  booking!: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'homeaway-action': HomeawayActionModel;
  }
}
